<template>
  <div class="mention-editor-container">
    <div
      :style="showSave ? 'width: calc(100% - 60px);' : ''"
      ref="editor"
      class="mention-editor"
      contenteditable="true"
      @input="onInput"
      @keydown="onKeyDown"
      @keyup="onKeyUp"
      @paste="onPaste"
      :placeholder="placeholder"
      v-testid="testid + 'editarea'"
    ></div>
    <v-icon
      v-if="showSave"
      :disabled="!isDirty"
      @click="emitContent(true)"
      :color="isDirty ? '#48A401' : 'grey'"
      title="Save Comment"
      v-testid="testid + 'editarea-save'"
      >mdi-send-variant-outline</v-icon
    >
    <v-icon class="ml-2"
      v-if="showSave"
      @click="$emit('cancel')"
      color="grey"
      title="Cancel"
      v-testid="testid + 'editarea-cancel'"
      >mdi-close</v-icon
    >
    <v-menu
      v-model="showMenu"
      absolute
      :position-x="menuPosition.left"
      :position-y="menuPosition.top"
      offset-y
      :close-on-content-click="true"
      nudge-width="250"
    >
      <v-list dense style="height: 500px; background-color: white;">
        <v-list-item style="background-color: white;"
          dense
          v-for="(item, index) in filteredItems"
          :key="item.id"
          @click="selectSubject(item)"
          :class="{ 'v-list-item--active': index === selectedIndex }"
          v-testid="testid + 'editarea-item' + index"
        >
          <v-list-item-icon class="mr-3" height="30">
            <!-- <v-avatar :color="item.mainRole ? item.mainRole.colour : 'teal'" size="24" v-if="item.type === 'user'" :title="item.mainRole ? item.mainRole.name : null"> -->
            <v-avatar
              :color="item.background_colour"
              size="24"
              v-if="item.type === 'user'"
            >
              <span
                style="font-size: 12px"
                :style="{ color: item.text_colour }"
              >
                <!--class="white--text"  {{ item.mainRole ? item.mainRole.abbr : ""}} -->
                {{
                  item.name
                    .split(" ")
                    .filter((x) => x)
                    .map((x) => x[0].toUpperCase())
                    .join("")
                }}
              </span> </v-avatar
            ><v-icon v-else>mdi-account-group</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <template v-if="item.type === 'review_group'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-title v-bind="attrs" v-on="on"
                    >{{ item.name }}
                    <v-icon
                      v-if="
                        item.review_group.users.some((u) => !u.userCanViewDoc)
                      "
                      small
                      color="amber"
                      class="ml-1"
                      >mdi-alert</v-icon
                    >
                    <!-- <v-icon
                          small color="gray"
                          v-bind="attrs"
                          v-on="on"
                        >mdi-information-box</v-icon> -->
                  </v-list-item-title>
                </template>
                <div>
                  <h4>Review Group Members:</h4>
                  <span>(notification will go to all users in group)</span>
                  <ul>
                    <li
                      v-for="(u, ui) in item.review_group.users"
                      :key="'u' + ui"
                    >
                      {{ u.user_name
                      }}<span v-if="!u.userCanViewDoc" style="font-size: 11px">
                        <v-icon color="amber" small class="ml-2 mr-1"
                          >mdi-alert</v-icon
                        >Document not currently visible</span
                      >
                    </li>
                  </ul>
                </div>
              </v-tooltip>
            </template>
            <template v-else>
              <v-tooltip bottom :disabled="item.userCanViewDoc">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-title v-bind="attrs" v-on="on"
                    >{{ item.name }}
                    <v-chip
                      v-if="item.mainRole"
                      label
                      small
                      outlined
                      class="px-1"
                      :color="item.mainRole.colour"
                      >{{ item.mainRole.name }}</v-chip
                    >
                    <v-icon
                      v-if="!item.userCanViewDoc"
                      small
                      color="amber"
                      class="ml-1"
                      >mdi-alert</v-icon
                    >
                  </v-list-item-title>
                </template>
                <div>
                  <h4>
                    Important: This user can only view the document when it is
                    in one of the following states:
                  </h4>
                  <ul>
                    <li
                      v-for="(s, si) in item.visible_statuses"
                      :key="'vss' + si"
                    >
                      <span>{{ s }}</span>
                    </li>
                  </ul>
                </div>
              </v-tooltip>
            </template>
          </v-list-item-content>
          <v-list-item-icon class="mr-0" height="30">
            <v-icon
              v-if="item.review_group_name"
              color="blue-grey"
              small
              title="Member of Review Group"
              >mdi-account-group</v-icon
            >
          </v-list-item-icon>
        </v-list-item>
        <v-list-item v-if="filteredItems.length === 0">
          <v-list-item-content>
            <v-list-item-title class="grey--text"
              >No items found</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import DOMPurify from "dompurify";

export default {
  name: "MentionEditor",
  props: {
    value: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "Add your comment...",
    },
    showSave: {
      type: Boolean,
      default: false,
    },
    setFocusTrigger: {
      type: Number,
      default: 0,
    },
    testid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showMenu: false,
      menuPosition: { top: 0, left: 0 },
      searchQuery: "",
      lastSearchQuery: "",
      selectedIndex: 0,
      mentionStartPos: null,
      skipCursorRestore: false,
      skipKeyUpCheck: false,
      isDirty: false,
    };
  },
  computed: {
    filteredItems() {
      if (!this.searchQuery) return this.items;
      const query = this.searchQuery.toLowerCase();
      return this.items.filter((x) => x.name.toLowerCase().includes(query));
    },
  },
  watch: {
    value(newVal) {
      if (this.$refs.editor) {
        this.$refs.editor.innerHTML = this.sanitizeHtml(newVal);
      }
    },
    setFocusTrigger(val) {
      if (val > 0) {
        this.$refs.editor.focus();
      }
    },
  },
  mounted() {
    if (this.value) {
      this.$refs.editor.innerHTML = this.sanitizeHtml(this.value);
    }
  },
  methods: {
    sanitizeHtml(html) {
      // Configure DOMPurify to only allow mention chip structure
      return DOMPurify.sanitize(html, {
        ALLOWED_TAGS: ["span", "br", "#text"],
        ALLOWED_ATTR: ["class", "data-mention-id", "contenteditable"],
        ALLOWED_CLASSES: {
          span: ["mention-editor-chip"],
        },
        KEEP_CONTENT: true,
        RETURN_DOM: false,
        RETURN_DOM_FRAGMENT: false,
        RETURN_DOM_IMPORT: false,
      });
    },
    sanitizeContent() {
      // Save cursor position as character offset before sanitization
      const selection = window.getSelection();
      let cursorOffset = null;

      if (selection.rangeCount > 0) {
        cursorOffset = this.getCursorOffset();
      }

      // Sanitize content
      const sanitized = this.sanitizeHtml(this.$refs.editor.innerHTML);

      if (this.$refs.editor.innerHTML !== sanitized) {
        this.$refs.editor.innerHTML = sanitized;

        // Restore cursor position if possible
        if (cursorOffset !== null) {
          this.$nextTick(() => {
            this.setCursorOffset(cursorOffset);
          });
        }
      }
    },
    getCursorOffset() {
      const selection = window.getSelection();
      if (!selection.rangeCount) return 0;

      const range = selection.getRangeAt(0);
      const preCaretRange = range.cloneRange();
      preCaretRange.selectNodeContents(this.$refs.editor);
      preCaretRange.setEnd(range.endContainer, range.endOffset);

      return preCaretRange.toString().length;
    },
    setCursorOffset(offset) {
      const selection = window.getSelection();
      const range = document.createRange();

      let currentOffset = 0;
      let found = false;

      const findOffset = (node) => {
        if (found) return;

        if (node.nodeType === Node.TEXT_NODE) {
          const length = node.textContent.length;
          if (currentOffset + length >= offset) {
            range.setStart(node, offset - currentOffset);
            range.collapse(true);
            found = true;
            return;
          }
          currentOffset += length;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          for (let i = 0; i < node.childNodes.length; i++) {
            findOffset(node.childNodes[i]);
            if (found) return;
          }
        }
      };

      findOffset(this.$refs.editor);

      if (found) {
        selection.removeAllRanges();
        selection.addRange(range);
      }
    },
    onInput(e) {
      this.isDirty = this.$refs.editor.innerHTML.trim().length > 0;
      this.emitContent();
    },
    onPaste(e) {
      // Prevent default paste behavior
      e.preventDefault();

      // Get plain text from clipboard
      const text = (e.clipboardData || window.clipboardData).getData(
        "text/plain"
      );

      // Insert as plain text at cursor position
      const selection = window.getSelection();
      if (selection.rangeCount) {
        const range = selection.getRangeAt(0);
        range.deleteContents();
        range.insertNode(document.createTextNode(text));
        range.collapse(false);
        selection.removeAllRanges();
        selection.addRange(range);
      }

      // Sanitize after paste
      this.sanitizeContent();

      // Trigger input event
      this.onInput();
    },
    emitContent(saved) {
      const rawHtml = this.$refs.editor.innerHTML;
      const sanitizedHtml = this.sanitizeHtml(rawHtml).replace(/&nbsp;/g, " ");
      const chips = this.$refs.editor.querySelectorAll(
        ".mention-editor-chip[data-mention-id]"
      );
      const ids = new Set();
      const mentioneditems = [];

      chips.forEach((chip) => {
        const id = chip.getAttribute("data-mention-id");
        if (!ids.has(id)) {
          ids.add(id);
          const item = this.items.find((u) => u.id === id);
          if (item) {
            mentioneditems.push({
              user:
                item.type === "user"
                  ? {
                      user_id: item.user_id,
                      userCanViewDoc: item.userCanViewDoc,
                    }
                  : null,
              review_group:
                item.type === "review_group" ? item.review_group : null,
            });
          }
        }
      });
      this.$emit(saved ? "save" : "input", {
        content: sanitizedHtml,
        mentions: mentioneditems,
      });
    },
    onKeyDown(e) {
      if (this.showMenu) {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          this.selectedIndex = Math.min(
            this.selectedIndex + 1,
            this.filteredItems.length - 1
          );
          return;
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          this.selectedIndex = Math.max(this.selectedIndex - 1, 0);
          return;
        } else if (e.key === "Enter" || e.key === "Tab") {
          e.preventDefault();
          if (this.filteredItems[this.selectedIndex]) {
            this.insertMention(this.filteredItems[this.selectedIndex]);
          }
          return;
        } else if (e.key === "Escape") {
          e.preventDefault();
          this.closeMenu();
          return;
        }
      }
    },

    onKeyUp(e) {
      if (["ArrowDown", "ArrowUp", "Enter", "Escape", "Tab"].includes(e.key)) {
        return;
      }
      // Skip if we just inserted a mention
      if (this.skipKeyUpCheck) {
        this.skipKeyUpCheck = false;
        return;
      }

      const selection = window.getSelection();
      if (!selection.rangeCount) return;

      const range = selection.getRangeAt(0);
      const textBeforeCursor = this.getTextBeforeCursor(range);

      const atMatch = textBeforeCursor.match(/@([\w\s]*)$/);

      if (atMatch) {
        if (!this.showMenu) {
          // Find the actual position of the @ symbol
          const mentionStart = this.findMentionStartPosition(
            range,
            atMatch[0].length
          );
          if (!mentionStart) {
            this.closeMenu();
            return;
          }
          this.mentionStartPos = mentionStart;
          this.selectedIndex = 0;
        }

        this.searchQuery = atMatch[1];
        // Only reset selectedIndex if search query changed
        if (this.searchQuery !== this.lastSearchQuery) {
          this.selectedIndex = 0;
          this.lastSearchQuery = this.searchQuery;
        }
        this.updateMenuPosition(range);
        this.showMenu = true;
      } else {
        this.closeMenu();
      }
    },

    getTextBeforeCursor(range) {
      // Get the text node and offset at cursor
      let node = range.startContainer;
      let offset = range.startOffset;

      // If we're in an element node, get the text content up to the cursor
      if (node.nodeType === Node.ELEMENT_NODE) {
        const textContent = node.textContent.substring(0, offset);
        return textContent.replace(/\u00A0/g, " ");
      }

      // If we're in a text node, we need to look backwards through siblings
      let text = node.textContent.substring(0, offset);
      let currentNode = node.previousSibling;

      // Walk backwards through siblings to build the text before cursor
      while (currentNode) {
        if (currentNode.nodeType === Node.TEXT_NODE) {
          text = currentNode.textContent + text;
        } else if (currentNode.nodeType === Node.ELEMENT_NODE) {
          // Stop at mention chips or other elements
          if (
            currentNode.classList &&
            currentNode.classList.contains("mention-editor-chip")
          ) {
            break;
          }
          text = currentNode.textContent + text;
        }
        currentNode = currentNode.previousSibling;
      }

      return text.replace(/\u00A0/g, " ");
    },

    findMentionStartPosition(range, matchLength) {
      // Walk backwards from cursor to find the exact position of @ symbol
      let remainingLength = matchLength;
      let node = range.startContainer;
      let offset = range.startOffset;

      // If we're in an element node, start from the last child
      if (node.nodeType === Node.ELEMENT_NODE) {
        // Get the text node at the offset position
        if (offset > 0 && node.childNodes[offset - 1]) {
          node = node.childNodes[offset - 1];
          offset = node.textContent.length;
        } else {
          return null;
        }
      }

      // Walk backwards through the text
      while (remainingLength > 0) {
        if (node.nodeType === Node.TEXT_NODE) {
          const textLength = offset;

          if (textLength >= remainingLength) {
            // Found it in this text node
            const newRange = document.createRange();
            newRange.setStart(node, offset - remainingLength);
            newRange.collapse(true);
            return newRange;
          }

          // Need to go to previous sibling
          remainingLength -= textLength;
          const prevSibling = node.previousSibling;

          if (!prevSibling) {
            // Try parent's previous sibling
            node = node.parentNode.previousSibling;
            if (!node) return null;
          } else {
            node = prevSibling;
          }

          // Stop at mention chips
          if (
            node.nodeType === Node.ELEMENT_NODE &&
            node.classList &&
            node.classList.contains("mention-editor-chip")
          ) {
            return null;
          }

          offset = node.textContent.length;
        } else {
          return null;
        }
      }

      return null;
    },

    updateMenuPosition(range) {
      const rect = range.getBoundingClientRect();
      const menuWidth = 200; // min-width of menu
      const menuHeight = 200; // max-height of menu
      const padding = 10; // padding from edge

      let top = rect.bottom + 5;
      let left = rect.left;
      if (left + menuWidth > window.innerWidth - padding) {
        left = window.innerWidth - menuWidth - padding;
      }
      if (left < padding) {
        left = padding;
      }
      if (top + menuHeight > window.innerHeight - padding) {
        // Position above cursor instead
        top = rect.top - menuHeight - 5;
        // If still doesn't fit, position at bottom with reduced height
        if (top < padding) {
          top = padding;
        }
      }
      this.menuPosition = { top, left };
    },

    insertMention(subject) {
      this.skipKeyUpCheck = true;
      const selection = window.getSelection();
      const range = this.mentionStartPos;

      // Delete the @ and search text
      const deleteRange = document.createRange();
      deleteRange.setStart(range.startContainer, range.startOffset);
      deleteRange.setEnd(
        selection.getRangeAt(0).endContainer,
        selection.getRangeAt(0).endOffset
      );
      deleteRange.deleteContents();

      // Create chip element
      const chip = document.createElement("span");
      // const innerspan = document.createElement("span");
      // chip.className = "mention-editor-chip v-chip v-chip--label v-chip--no-color theme--light v-size--x-small";
      chip.className = "mention-editor-chip";
      chip.setAttribute("contenteditable", "false");
      chip.setAttribute("data-mention-id", subject.id);
      // innerspan.className = "v-chip__content";
      chip.textContent = `@${
        (subject.type === "review_group" ? "[RG] " : "") + subject.name
      }`;
      // chip.appendChild(innerspan);

      // Insert chip
      deleteRange.insertNode(chip);

      // Add space after chip
      const space = document.createTextNode("\u00A0");
      chip.parentNode.insertBefore(space, chip.nextSibling);

      // Move cursor after space
      const newRange = document.createRange();
      newRange.setStartAfter(space);
      newRange.collapse(true);
      selection.removeAllRanges();
      selection.addRange(newRange);

      this.closeMenu();
      this.emitContent();
      this.$refs.editor.focus();
    },

    selectSubject(subject) {
      this.insertMention(subject);
    },

    closeMenu() {
      this.showMenu = false;
      this.searchQuery = "";
      this.lastSearchQuery = "";
      this.selectedIndex = 0;
      this.mentionStartPos = null;
    },
  },
};
</script>
<style>
.mention-editor-chip {
  font-size: 13px;
  height: 16px;
  font-weight: 500;
  background-color: #eeeeee;
  color: rgba(0, 0, 0, 0.87);
  padding-left: 3px;
  padding-right: 3px;
  line-height: 1.5;
}
</style>

<style scoped>
.mention-editor-container {
  position: relative;
  border: 1px solid #cccccc;
  border-radius: 8px;
  background-color: #ffffff;
  display: flex;
}

.mention-editor {
  padding: 6px 8px;
  max-height: 300px;
  overflow-y: auto;
  outline: none;
  line-height: 1.5;
  letter-spacing: 0%;
  font-size: 14px;
  font-family: "DM Sans";
  font-weight: 400;
}

.mention-editor:focus {
  border-color: #1976d2;
}
.v-list-item--active {
  background-color: rgb(218, 231, 235);
}

[contenteditable="true"]:empty:before {
  content: attr(placeholder);
  pointer-events: none;
  display: block; /* For Firefox */
}
</style>